<template>
  <div>
    <!-- 这个是退款结算 -->
    <div v-show="isShowDetail">
      <div
        v-if="!isShow"
        class="item-box-content mainStep"
      >
        <el-row v-if="state===1||state===0||state===2">
          <el-col :span="12">
            <div class="title-font-style">
              <span>退款结算</span>
            </div>
          </el-col>
        </el-row>
        <div v-if="state ===1||state ===0||state ===2">
          <return-money-message :params="params"></return-money-message>
          <div>
            <el-steps
              align-center
              :active="state+1"
              class="step-margin"
            >
              <el-step
                title="确认结算方案"
                icon="el-icon-success"
              ></el-step>
              <el-step
                title="收付款"
                icon="el-icon-success"
              ></el-step>
              <el-step
                title="结算成功"
                icon="el-icon-success"
              ></el-step>
            </el-steps>
          </div>
          <div class="step-margin-sec">
            <div v-if="state ===0">
              <span class="style-title">请选择结算方案:</span>
              <el-radio-group
                v-model="tabPosition"
                style="margin-left: 10px;"
              >
                <el-radio-button label="原合同结算">原合同结算</el-radio-button>
                <el-radio-button label="罚没金另行支付">罚没金另行支付</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="state ===1||state ===2">
              <span
                v-if="status ===1"
                class="style-title"
              >结算方式：原合同结算</span>
              <span
                v-if="status ===2"
                class="style-title"
              >结算方式：罚没金另行支付</span>
            </div>
            <div v-if="state ===0">
              <el-table
                border
                ref="tableRef"
                :data="dataList"
                max-height="378"
                tooltip-effect="dark"
                class="table-style"
                :header-cell-style="tableHeader"
              >
                <el-table-column
                  show-overflow-tooltip
                  prop="name"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="beforeMoney"
                  label="结算前"
                >
                  <template slot-scope="scope">{{scope.row.beforeMoney| priceFilterNum}}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="afterMoney"
                  label="结算后"
                >
                  <template slot-scope="scope">{{scope.row.afterMoney| priceFilterNum}}</template>
                </el-table-column>
              </el-table>
              <div
                v-if="tabPosition ==='罚没金另行支付'"
                style="margin:10px auto 0px;"
              >
                客担罚没金：
                <span style="color:#d56666;">{{params.confiscatedTotal| priceFilterNum}}</span>元，需另外发起付款申请
              </div>
              <el-button
                style="margin-top:10px;"
                @click="addRepayment"
                type="primary"
              >提交
              </el-button>
              <div class="title-text">
                <span class="text-title">{{'*方案提交后不可回退，请慎重选择'}}</span>
              </div>
            </div>
            <div v-if="state ===1||state ===2">
              <el-table
                border
                ref="tableRef"
                :data="dataList"
                max-height="378"
                tooltip-effect="dark"
                class="table-style"
                :header-cell-style="tableHeader"
              >
                <el-table-column
                  show-overflow-tooltip
                  prop="name"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="beforeMoney"
                  label="结算前"
                >
                  <template slot-scope="scope">{{scope.row.beforeMoney| priceFilterNum}}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="afterMoney"
                  label="结算后"
                >
                  <template slot-scope="scope">{{scope.row.afterMoney| priceFilterNum}}</template>
                </el-table-column>
              </el-table>
              <div
                v-if="state ===1 &&status ===2"
                style="margin:10px auto 0px;"
              >
                客担罚没金：
                <span style="color:#d56666;">{{params.confiscatedTotal| priceFilterNum}}</span>元，需另外发起付款申请
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isShow&&state !==0">
        <div
          class="item-box-content"
          v-if="state !==0 &&status ===1&& statusYesOrNo ===1"
        >
          <el-row>
            <el-col :span="12">
              <div class="title-font-style">
                <span>收款申请</span>
              </div>
            </el-col>
          </el-row>
          <div
            class="item-box-content"
            style="padding-left:30px;padding-bottom:0px;padding-right:30px;"
          >
            <div>可申请收款金额：{{params.retreatReceiptAllVo.applicableMoney | toFixed}}</div>
            <el-table
              border
              ref="tableRef"
              :data="params.retreatReceiptAllVo.retreatReceiptVoList"
              max-height="378"
              tooltip-effect="dark"
              style="margin-top:20px;"
              :header-cell-style="tableHeader"
            >
              <el-table-column
                show-overflow-tooltip
                prop="receiptNumber"
                label="收款编号"
              >
                <template slot-scope="scope">
                  <div
                    class="approval line-limit-length"
                    @click="toCustormDetail(scope.row.pcrrId)"
                  >{{ scope.row.receiptNumber }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="receiptType"
                label="收款类型"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="state"
                label="收款状态"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="receiprMoney"
                label="申请收款金额"
              >
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.receiprMoney | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="receiprMoneyEnd"
                label="已收金额"
              >
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.receiprMoneyEnd | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="processUser"
                label="申请人"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="processDate"
                label="申请时间"
              ></el-table-column>
            </el-table>
            <el-button
              v-if="state ===1"
              :disabled="params.retreatReceiptAllVo.applicableMoney === 0"
              style="margin-top:20px;"
              type="primary"
              @click="applyForCredit"
            >申请收款
            </el-button>
          </div>
        </div>
        <!--        &&status ===2-->
        <div v-if="state !== 0 &&status ===2 &&statusYesOrNo ===1">
          <div
            class="item-box-content"
            style="padding-top:0px !important;"
          >
            <div
              class="bold"
              style="position:absolute;margin-top:20px"
            ></div>
            <el-tabs
              style="padding-left:30px;padding-right:35px;padding-top:10px !important"
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                label="收款申请"
                name="first"
              >
                <div>可申请收款金额：{{params.retreatReceiptAllVo.applicableMoney.toFixed(2)}}</div>
                <el-table
                  border
                  ref="tableRef"
                  :data="params.retreatReceiptAllVo.retreatReceiptVoList"
                  max-height="378"
                  tooltip-effect="dark"
                  style="margin-top:20px;"
                  :header-cell-style="tableHeader"
                >
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiptNumber"
                    label="收款编号"
                  >
                    <template slot-scope="scope">
                      <div
                        class="approval line-limit-length"
                        @click="toCustormDetail(scope.row.pcrrId)"
                      >{{ scope.row.receiptNumber }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiptType"
                    label="收款类型"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="state"
                    label="收款状态"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiprMoney"
                    label="申请收款金额"
                  >
                    <template slot-scope="scope">
                      <div class="line-limit-length">{{ scope.row.receiprMoney | priceFilterNum}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiprMoneyEnd"
                    label="已收金额"
                  >
                    <template slot-scope="scope">
                      <div class="line-limit-length">{{ scope.row.receiprMoneyEnd | priceFilterNum}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="processUser"
                    label="申请人"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="processDate"
                    label="申请时间"
                  ></el-table-column>
                </el-table>
                <el-button
                  v-if="state ===1"
                  style="margin-top:20px;"
                  type="primary"
                  :disabled="params.retreatReceiptAllVo.applicableMoney === 0"
                  @click="applyForCredit"
                >申请收款
                </el-button>
              </el-tab-pane>
              <el-tab-pane
                label="付款申请"
                name="second"
              >
                <div>可申请付款金额：{{params.retreatReceiptAllVos.applicableMoney.toFixed(2)}}</div>

                <el-table
                  border
                  ref="tableRef"
                  :data="params.retreatReceiptAllVos.retreatReceiptVoList"
                  max-height="378"
                  tooltip-effect="dark"
                  style="margin-top:20px;"
                  :header-cell-style="tableHeader"
                >
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiptNumber"
                    label="付款编号"
                  >
                    <template slot-scope="scope">
                      <div
                        class="approval line-limit-length"
                        @click="toCustormDetailPay(scope.row.pcrrId)"
                      >{{ scope.row.receiptNumber }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiptType"
                    label="付款类型"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="state"
                    label="付款状态"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiprMoney"
                    label="申请付款金额"
                  >
                    <template slot-scope="scope">
                      <div class="line-limit-length">{{ scope.row.receiprMoney | priceFilterNum}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="receiprMoneyEnd"
                    label="已付金额"
                  >
                    <template slot-scope="scope">
                      <div class="line-limit-length">{{ scope.row.receiprMoneyEnd | priceFilterNum}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="processUser"
                    label="申请人"
                  ></el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="processDate"
                    label="申请时间"
                  ></el-table-column>
                </el-table>
                <el-button
                  v-if="state ===1"
                  :disabled="params.retreatReceiptAllVos.applicableMoney === 0"
                  style="margin-top:20px;"
                  type="primary"
                  @click="applyForCredit(1)"
                >申请付款
                </el-button>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <!-- 这里收款申请 是申请 -->
      <div v-if="state!==0 ">
        <div v-show="isShow">
          <apply-for-credit
            ref="applyForCreditRefs"
            v-if="!isshowPay"
            :money="params.retreatReceiptAllVo.applicableMoney"
            :suNameList="suNameList"
            :pcrsId="params.pcrsId"
            @getList="getList"
            :receiptType="'采购退货收款'"
          ></apply-for-credit>
          <pay-for-credit
            v-if="isshowPay"
            ref="aapayForCreditRefs"
            :money="params.retreatReceiptAllVos.applicableMoney"
            :suNameList="suNameList"
            :pcrsId="params.pcrsId"
            @getList="getList"
            :receiptType="'采购退货罚没'"
          ></pay-for-credit>
        </div>
      </div>
    </div>
    <div v-show="!isShowDetail">
      <return-money-details
        v-show="payOrPayee"
        ref="returnMoneyDetailsRefs"
      ></return-money-details>
      <return-money-details-payee
        v-show="!payOrPayee"
        ref="returnMoneyDetailsPayeeRefs"
      ></return-money-details-payee>
    </div>
  </div>
</template>
<script>
// import { financeUploadFile } from '@/api/fiance/fianceManage'
import { queryRepaymentScheme, addRepaymentScheme } from '@/api/purchase/purchasePlanList'
import { deepClone } from '@/util'
import { formatDate } from '@/util/tool'
import applyForCredit from './applyForCredit'
import payForCredit from './payForCredit'
import returnMoneyMessage from './returnMoneyMessage'
import returnMoneyDetails from './returnMoneyDetails'
import returnMoneyDetailsPayee from './returnMoneyDetailsPayee'

export default {
  components: {
    'apply-for-credit': applyForCredit,
    'pay-for-credit': payForCredit,
    'return-money-details': returnMoneyDetails,
    'return-money-details-payee': returnMoneyDetailsPayee,
    'return-money-message': returnMoneyMessage
  },
  data () {
    return {
      radio: 1,
      payOrPayee: false,
      isShowDetail: true,
      isShow: false, // 这里收款申请的状态是否显示
      fileList: [],
      contactList: ['待审核', '审核中', '履行中', '已履行', '待签署', '已作废', '合同审核不通过', '盖章审核驳回', '盖章审核'],
      state: 2, // (0:确认方案,1存在结算费用(发起),2存在结算费用(成功)3发起申请,)
      status: 0, // (1.原合同2.罚没金),
      statusYesOrNo: 0, // (1.有2.无),
      storge: [],
      isshowPay: false,
      params: {
        cbackAfter: 0,
        cbackBefore: 0,
        ccopeAfter: 0,
        ccopeBefore: 0,
        cdueAfter: 0,
        cdueBefore: 0,
        confiscatedRadio: 0,
        confiscatedTotal: 0,
        cundueAfter: 0,
        cundueBefore: 0,
        payScheme: 0,
        pcrsId: 0,
        purchaseContractBasesVo: {
          accountsDue: 0,
          accountsOutstanding: 0,
          accountsPayable: 0,
          actualTotal: 0,
          contractFrom: '',
          contractState: 0,
          pcbId: 0,
          pcbNumber: '',
          purchaseTotal: 0,
          sendType: '',
          signTime: '',
          spId: 0,
          staffUsename: '',
          suName: '',
          supplierContractNumber: '',
          updateDate: ''
        },
        rbackAfter: 0,
        rbackBefore: 0,
        rcopeAfter: 0,
        rcopeBefore: 0,
        rdueAfter: 0,
        rdueBefore: 0,
        retreatReceiptAllVo: {
          applicableMoney: 0,
          retreatReceiptVoList: [
            {
              pcrrId: 0,
              processDate: '',
              processUser: '',
              receiprMoney: 0,
              receiprMoneyEnd: 0,
              receiptNumber: '',
              receiptType: '',
              state: ''
            }
          ]
        },
        retreatReceiptAllVos: {
          applicableMoney: 0,
          retreatReceiptVoList: [
            {
              pcrrId: 0,
              processDate: '',
              processUser: '',
              receiprMoney: 0,
              receiprMoneyEnd: 0,
              receiptNumber: '',
              receiptType: '',
              state: ''
            }
          ]
        }
      },
      queryParams: {},
      dataList: [],
      suNameList: {},
      dataListBefore: [
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        }
      ],
      dataListAfter: [
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        },
        {
          name: '',
          beforeMoney: 0,
          afterMoney: 0
        }
      ],
      tabPosition: '原合同结算',
      activeName: 'first',
      tabPositionState: 1
    }
  },
  watch: {
    tabPosition: {
      handler (ele) {
        if (ele === '罚没金另行支付') {
          this.tabPositionState = 2
          this.dataList = deepClone(this.dataListAfter)
        } else {
          this.dataList = deepClone(this.dataListBefore)
          this.tabPositionState = 1
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    // 收款详情(){
    toCustormDetail (type) {
      this.isShowDetail = false
      this.payOrPayee = false
      this.$refs.returnMoneyDetailsPayeeRefs.getList(type)
    },
    // 付款详情
    toCustormDetailPay (type) {
      this.isShowDetail = false
      this.payOrPayee = true
      this.$refs.returnMoneyDetailsRefs.getList(type)
    },
    // 申请收款
    applyForCredit (type) {
      this.isShow = true
      if (type === 1) {
        this.isshowPay = true
        const that = this
        this.$nextTick(() => {
          setTimeout(() => {
            that.$refs.aapayForCreditRefs.getList(type)
          }, 200)
        })
      } else {
        this.isshowPay = false
        this.$refs.applyForCreditRefs.getList(type)
      }
    },
    // 确认结算方案提交
    addRepayment () {
      addRepaymentScheme(this.$route.query.pcrId, this.tabPositionState).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('方案提交成功！')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getList () {
      this.tabPosition = '原合同结算'
      this.isShow = false
      this.isShowDetail = true
      queryRepaymentScheme(this.$route.query.pcrId).then((res) => {
        if (res.data.code === 200) {
          this.suNameList.suName = res.data.obj.purchaseRetreatVo.suName
          this.suNameList.suId = res.data.obj.purchaseRetreatVo.suId
          this.params = res.data.obj.repaymentSchemesVo
          this.dataListBefore[0].name = '合同应付账款'
          this.dataListBefore[1].name = '已到期账款'
          this.dataListBefore[2].name = '未到期账款'
          this.dataListBefore[3].name = '供应商退还金额'
          this.dataListBefore[0].beforeMoney = this.params.rcopeBefore
          this.dataListBefore[1].beforeMoney = this.params.rdueBefore
          this.dataListBefore[2].beforeMoney = this.params.rundueBefore
          this.dataListBefore[3].beforeMoney = this.params.rbackBefore
          this.dataListBefore[0].afterMoney = this.params.rcopeAfter
          this.dataListBefore[1].afterMoney = this.params.rdueAfter
          this.dataListBefore[2].afterMoney = this.params.rundueAfter
          this.dataListBefore[3].afterMoney = this.params.rbackAfter
          this.dataListAfter[0].name = '合同应付账款'
          this.dataListAfter[1].name = '已到期账款'
          this.dataListAfter[2].name = '未到期账款'
          this.dataListAfter[3].name = '供应商退还金额'
          this.dataListAfter[0].beforeMoney = this.params.ccopeBefore
          this.dataListAfter[1].beforeMoney = this.params.cdueBefore
          this.dataListAfter[2].beforeMoney = this.params.cundueBefore
          this.dataListAfter[3].beforeMoney = this.params.cbackBefore
          this.dataListAfter[0].afterMoney = this.params.ccopeAfter
          this.dataListAfter[1].afterMoney = this.params.cdueAfter
          this.dataListAfter[2].afterMoney = this.params.cundueAfter
          this.dataListAfter[3].afterMoney = this.params.cbackAfter
          this.dataList = deepClone(this.dataListBefore)
          if (this.params.state === '确认结算方案') {
            this.state = 0
          } else if (this.params.state === '收付款') {
            this.state = 1
            if (this.params.payScheme === 1) {
              this.status = 1
              // 原合同
              if (this.params.rbackAfter !== 0) {
                this.statusYesOrNo = 1
              } else {
                this.statusYesOrNo = 2
              }
              this.dataList = deepClone(this.dataListBefore)
            } else if (this.params.payScheme === 2) {
              // 罚没金
              this.status = 2
              if (this.params.cbackAfter !== 0 || this.params.confiscatedTotal !== 0) {
                this.statusYesOrNo = 1
              } else {
                this.statusYesOrNo = 2
              }
              this.dataList = deepClone(this.dataListAfter)
              // if (this.params.confiscatedRadio !== 0) {
              //   this.statusYesOrNo = 1
              // } else {
              //   this.statusYesOrNo = 2
              // }
            }
          } else if (this.params.state === '结算成功') {
            this.state = 2
            if (this.params.payScheme === 1) {
              this.status = 1
              // 原合同
              if (this.params.rbackAfter !== 0) {
                this.statusYesOrNo = 1
              } else {
                this.statusYesOrNo = 2
              }
              this.dataList = deepClone(this.dataListBefore)
            } else if (this.params.payScheme === 2) {
              // 罚没金
              this.status = 2
              if (this.params.cbackAfter !== 0 || this.params.confiscatedTotal !== 0) {
                this.statusYesOrNo = 1
              } else {
                this.statusYesOrNo = 2
              }
              this.dataList = deepClone(this.dataListAfter)
            }
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    handleClick () {

    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style
  lang="scss"
  scoped
>
  .title-text {
    margin: 10px 0 14px;

    .text-title {
      font-size: 12px;
      font-weight: 400;
      color: #d35e5e;
      line-height: 12px;
    }
  }

  .step-margin {
    margin: auto;
    padding: 20px;
    margin-top: 20px;
  }

  .step-margin-sec {
    margin-left: 30px;
    margin-right: 30px;
  }

  .table-style {
    margin-top: 20px;
    margin-right: 20px;
  }

  .style-title {
    font-size: 15px;
    font-weight: 600;
  }
</style>
